import {
  FETCH_START,
  FETCH_END,
  TERRITORY_FORMAT_SUCCESS,
  TERRITORY_FORMAT_BY_ID_SUCCESS,
  TERRITORY_FORMAT_FIELDS_SUCCESS,
  TERRITORY_UPLOAD_SUCCESS,
} from '../../actions/Territory/ActionTypes';

const initialState = {
  loading: false,
  territoryFormatData: [],
  territoryFormatFieldData: [],
  territorySingleFormatData: [],
  territoryDataErrorList: [],
};

const TerritoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case TERRITORY_FORMAT_SUCCESS:
      return {
        ...state,
        territoryFormatData: action.data,
      };
    case TERRITORY_FORMAT_BY_ID_SUCCESS:
      return {
        ...state,
        territorySingleFormatData: action.data,
      };
    case TERRITORY_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        territoryFormatFieldData: action.data,
      };
    case TERRITORY_UPLOAD_SUCCESS:
      return {
        ...state,
        territoryDataErrorList: action.data,
      };
    default:
      return state;
  }
};

export default TerritoryReducer;
